export default __webpack_public_path__ + "static/media/Website-Blur2.bf6d23ad.png";